import PropTypes from "prop-types";
import { TEAM_INVITES_UI_ENABLED } from "@/lib/featureFlags";
import { useTeamSettings } from "@/pages/settings/useTeamSettings";
import { TeamMembersPanel, TeamPendingInvitesPanel } from "@/pages/settings/TeamSettingsPanels";
import { TeamRoleGuide } from "@/pages/settings/TeamRoleGuide";
import { TeamSettingsDialogs } from "@/pages/settings/TeamSettingsDialogs";

export function TeamSettingsSection({ Shell, after = null }) {
  const team = useTeamSettings();

  return (
    <Shell
      title="Team & Roles"
      desc={TEAM_INVITES_UI_ENABLED
        ? "Manage workspace members, roles, and pending invitations."
        : "View workspace members and roles."}
    >
      <div className="p-4 sm:p-6 grid grid-cols-12 gap-4 sm:gap-5 min-w-0">
        <div className="col-span-12 lg:col-span-8 space-y-4 min-w-0">
          <TeamMembersPanel
            members={team.members}
            loading={team.loading}
            workspaceLabel={team.workspaceLabel}
            inviteDisabledReason={team.inviteDisabledReason}
            currentUserId={team.currentUserId}
            canManageMembers={team.canManageMembers}
            onOpenRoleDialog={team.openRoleDialog}
            onRemove={team.setRemoveTarget}
            onInviteClick={() => team.setInviteOpen(true)}
          />
          <TeamPendingInvitesPanel
            pendingInvites={team.pendingInvites}
            loading={team.loading}
            canInvite={team.canInvite}
            revokingId={team.revokingId}
            onRevoke={team.revokeInvite}
          />
        </div>

        <div className="col-span-12 lg:col-span-4">
          <TeamRoleGuide />
        </div>
      </div>

      {after}

      <TeamSettingsDialogs team={team} />
    </Shell>
  );
}

TeamSettingsSection.propTypes = {
  Shell: PropTypes.elementType.isRequired,
  after: PropTypes.node,
};
